"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useToggle = useToggle;
var _react = require("react");
function useToggle() {
  let initialState = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
  // Initialize the state
  const [stateValue, setStateValue] = (0, _react.useState)(initialState);

  // Define and memorize toggle function in case we pass down the component,
  // This function change the boolean value to it's opposite value
  const toggle = (0, _react.useCallback)(() => setStateValue(state => !state), []);
  return [stateValue, toggle];
}